import { HttpEvent } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface FileManagerDataService {
  getSources(folder: string): Observable<FilesAndFolders>;
  upload(folder: string, files: FileList): Observable<HttpEvent<unknown>>;
  deleteFolder(folder: string): Observable<unknown>;
  deleteFile(fileId: string): Observable<unknown>;
}

export interface FilesAndFolders {
  files: StaticFile[];
  folders: string[];
}

export interface StaticFile {
  id: string;
  name: string;
  fullPath: string;
  category: FileExtensionCategory;
  thumbnailFullPath: string;
}

export enum FileExtensionCategory {
  Image = 1,
  Video = 2,
  Audio = 3,
  Document = 4,
  Other = 5
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const FILE_MANAGER_SERVICE_TOKEN = new InjectionToken<FileManagerDataService>('FileManagerService');
